module.exports = __webpack_public_path__ + "img/GD.b6b7ce3b.png";